// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFileUpload-Input_cls1__2NnEW","cls2":"VeloFileUpload-Input_cls2__HXrXQ VeloFileUpload-Input_cls1__2NnEW"};